import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import styles from "./index.module.scss";
import { handleImage } from "../../handlers";
import { buildWhatsAppUrl } from "../../../utils/whatsapp.mjs";

export default function Systems({ data, page = "", siteInfo }) {
    const { locale } = useRouter();
    const renderSystems = data?.items?.map((item, k) => (
        <Col xs="12" md="6" key={k}>
            <Link
                href={item.url || ""}
                scroll={!!item.url}
                aria-label="system-link"
            >
                <div className="system" key={"service" + k}>
                    {/* <Link className={`btn bg-white`} href={`/systems/${item.slug}`}> */}
                    <div>
                        <div className="img-wrapper m-auto">
                            <Image
                                src={handleImage(item?.icon)}
                                width={55}
                                height={55}
                                alt={item?.title || ""}
                                // objectFit="contain"
                            />
                        </div>
                        <h3 className="py-3 unique-bold">
                            {item.heading?.[locale]}
                        </h3>
                        <div
                            className="py-3 p"
                            dangerouslySetInnerHTML={{
                                __html: item.description?.[locale],
                            }}
                        ></div>
                        {/* <FormattedMessage id="read-more" /> */}
                        {/* <Image {...arrow} width={22} height={22} alt="" /> */}
                    </div>
                    {/* </Link> */}
                </div>
            </Link>
        </Col>
    ));

    return (
        <div className={`${styles.systems} wrapper w-100`}>
            <Row className=" ">
                <div className={` info`}>
                    <div className="pb-1 ">
                        <h2>
                            <span className="section-tag text-dark m-auto">
                                <FormattedMessage id="alnjoom-systems" />
                            </span>
                        </h2>
                    </div>
                    <h2 className="pb-2 fw-bold">{data?.heading?.[locale]}</h2>
                    {/* <p className="pb-4 mb-1 ">{data?.description?.[locale]}</p> */}
                </div>
                <Row className="systems-wrapper">{renderSystems}</Row>
                {page != "systems" && (
                    <>
                        {/* <div className="pb-4">
                            <Link
                                href="/systems"
                                className="btn gradient-btn"
                                aria-label="all-systems"
                            >
                                <span>
                                    <FormattedMessage id="read-more" />
                                </span>
                            </Link>
                        </div> */}
                        <div className="rounded-5 whatsapp">
                            <Link
                                href={buildWhatsAppUrl(siteInfo?.whatsup)}
                                aria-label="whatsapp"
                            >
                                    <FormattedMessage id="send-whatsapp" />
                            </Link>
                        </div>
                    </>
                )}
            </Row>
        </div>
    );
}
